import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FormGroup, Table, Input, Label, Form, Card, CardHeader, CardFooter, CardText, CardBody, Button } from 'reactstrap';
import '../GerenciamentoTurmas/GerenciamentoTurmas.css';
import { Search, Envelope, JournalBookmark } from 'react-bootstrap-icons';

const PesquisaRapida = ({ putIntegrante, buscarAlunoPorNome, putIntegranteRegistro, alunos }) => {
    const [nomeAlunoPesquisa, setNomeAlunoPesquisa] = useState();

    const renderlistaAlunos = () => {
        let renderedList = [];
        for (let aluno of alunos) {
            renderedList.push(renderAlunoSingle(aluno));
        }
        return renderedList;
    }

    const checkForEnter = (e) => {
        let key = e.key;
        if (key === "Enter" || key === "NumpadEnter") {
            buscarAlunoPorNome(nomeAlunoPesquisa);
        }
    }

    const renderAlunoSingle = (aluno) => {
        console.log(aluno);
        return (
            <div className="tabelaItem" >
                <h8 className="tabelaComponent" onClick={() => putIntegrante(aluno["cdAluno"])}>
                    {aluno["nome"] + " (" + aluno["nomeTurma"] + ") "}
                </h8>
                <JournalBookmark size={25} className="tabelaComponent" onClick={() => putIntegranteRegistro(aluno["cdAluno"], false)} />
            </div>
        );
    }
    return (<>
        <h2 className="titulosPaginas">Pesquisa Rápida</h2>
        <div className="pesquisaRapidaPorNomeDiv">
            <input type="text" placeholder="Buscar por Nome do Aluno" className="pesquisaRapidaTurmas"
            onChange={(e) => setNomeAlunoPesquisa(e.target.value)} onKeyPress={checkForEnter}/>
        <Button className="searchDataButton" onClick={() => buscarAlunoPorNome(nomeAlunoPesquisa)}>
            <Search />
            </Button>
         </div>
        <FormGroup>
            <div className="TabelaConfig">
                <div hover={true} className="TabelaGer">
                    <div className="tabelaItem">
                        <h6 className="titulosTabelas">
                            NOME DO ALUNO
                        </h6>
                        <h6 className="titulosTabelas">
                            OPÇÕES
                        </h6>
                    </div>
                </div>
                {alunos && renderlistaAlunos()}
            </div>
        </FormGroup>
    </>);
}

export default PesquisaRapida;